import { mergePropertiesGroup } from './merge-properties-group';
export default mergePropertiesGroup;
